import { useRMSelector } from 'redux/hooks';

export const useSettingsTab = () => {
  return useRMSelector((state) => state.settingsTab);
};
